import { connect } from 'react-redux';
import { v4 } from 'uuid';

import FunnelContainer from '../../components/funnel/Container';
import {
  getLocation,
  getPreviousLocation,
  getSelectedFunnel,
  getTenantId,
  getUpdatingFunnel,
  isFunnelExecuting,
} from '../../reducers/analyticsApp';
import { executeFunnel, setFunnelExecuteId } from '../../actions/funnel';
import isFunnelReadyToExecute from '../../utils/funnel';

const isExecuteDisabled = (state) => {
  const selectedFunnel = getSelectedFunnel(state);
  const updatingFunnel = getUpdatingFunnel(state);
  return selectedFunnel ? !isFunnelReadyToExecute(selectedFunnel, updatingFunnel) : true;
};

const mapStateToProps = (state) => {
  const selectedFunnel = getSelectedFunnel(state);
  const previousLocation = getPreviousLocation(state) || '';
  const location = getLocation(state);
  const tenantId = getTenantId(state);
  const isFunnelsTabOpen =
    selectedFunnel && !previousLocation.includes('funnels') && location.includes('funnels');

  return {
    isFunnelsTabOpen,
    selectedFunnel,
    executing: isFunnelExecuting(state),
    executeDisabled: isExecuteDisabled(state),
    tenantId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onExecute: () => {
    const executeId = v4();
    dispatch(setFunnelExecuteId(executeId));
    return dispatch(executeFunnel(executeId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FunnelContainer);
